import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const removeMyMonitoringUser = async (userId: number, unitId: string): Promise<boolean> =>
  axios.delete(`/my-monitoring/sites/RemoveMyMonitoringUser?userId=${userId}&unitId=${unitId}`).then((res) => res?.data?.result)

type Props = {
  userId: number
  unitId: string
}

export const useMyMonitoringRemoveMyMonitoringUser = (
  notify?: boolean,
  onSuccess?: (data: boolean) => void,
  successMsg?: string,
  errorMsg?: string
) =>
  useMutation({
    mutationKey: ['removeMyMonitoringUser'],
    mutationFn: ({ userId, unitId }: Props) => removeMyMonitoringUser(userId, unitId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess(successMsg || 'Removed user.')
      }
    },
    onError: () => {
      if (notify) {
        toastError(errorMsg || 'Failed to remove user.')
      }
    },
    throwOnError: false
  })
